<template>
	<div v-if="contentComposition">
		<iframe
			scrolling="no"
			:src="compositionUrl"
			class="element-position"
			:class="className"
			:style="style"
			v-if="isComposition"
		/>
		<!-- @TODO: -->
	</div>
</template>

<script>
import RTC from 'detectrtc';
import { duplicateVar } from '@/lib/helper';
import rundownItemsApi from '@/api/rundownItems';

export default {
	name: 'ElementComposition',
	props: {
		item: {
			type: Object,

		},
	},
	data() {
		return {
			// composition error
			videoOptions: [],
			programOptions: [],
			localItem: null,
		};
	},
	sockets: {
		connect() {
			// this.activateSocket();
		},
		force_play_item(data) {
			if (this.localItem.id === data.id) {
				this.localItem = duplicateVar(data);
			}
		},
	},
	created() {
		this.localItem = duplicateVar(this.item);
	},
	watch: {
		item() {
			if (this.item) {
				this.localItem = duplicateVar(this.item);
			}
		},
	},
	mounted() {
		this.initDevices();
	},
	methods: {
		initDevices() {
			RTC.load(() => {
				RTC.MediaDevices.map((device) => {
					if (device.kind === 'videoinput') {
						this.videoOptions.push(device);
						this.programOptions.push(device);
					}
					return device;
				});
			});
		},
		compositionItem(item) {
			const itemParse = JSON.parse(item.content);
			const responseDeviceId = itemParse && itemParse.composition && itemParse.composition.device_id;
			const deviceIdComposition = this.videoOptions.find(({ deviceId }) => deviceId === responseDeviceId);
			if (!deviceIdComposition) {
				return null;
			}
			return deviceIdComposition;
		},
		onCompletePlay(itemId) {
			const callback = () => {
			};
			const errorCallback = () => {
			};
			rundownItemsApi.playLive(itemId, callback, errorCallback);
		},
	},
	beforeDestroy() {
		// if (this.status === 'live') {
		// 	if (this.content && this.content.onCompleteItem) {
		// 		this.onCompletePlay(this.content.onCompleteItem);
		// 	}
		// }
	},
	computed: {
		content() {
			return this.localItem.content && this.localItem.content !== ''
				? JSON.parse(this.localItem.content) : {};
		},
		contentComposition() {
			return this.content && this.content.composition ? this.content.composition : null;
		},
		className() {
			return this.content.position ? this.content.position : '';
		},
		style() {
			const style = {};
			style.position = 'absolute';
			style.border = '0';
			style.zIndex = this.localItem.layer_index;
			const content = this.content;
			if (content.opacity) style.opacity = content.opacity;
			if (content.width) style.width = `${content.width}px`;
			if (content.height) style.height = `${content.height}px`;
			if (content.y) style.top = `${content.y}px`;
			if (content.x) style.left = `${content.x}px`;
			return style;
		},
		// eslint-disable-next-line
		isComposition() {
			if (this.localItem) {
				if (!this.contentComposition) {
					this.$notify({
						group: 'app',
						type: 'warn',
						title: 'Composition Error',
						duration: 4000,
						text: 'You have not selected any compositions',
					});
				}
				return this.localItem.type === 'composition' && this.contentComposition;
			}
		},
		compositionUrl() {
			const id = this.content.composition && this.content.composition.id;
			const isShowEditor = this.content.composition && this.content.showEditor;
			if (!isShowEditor) {
				return `${process.env.VUE_APP_URL}/compositions/view/${id}?editorVisible=${isShowEditor}`;
			}
			return `${process.env.VUE_APP_URL}/compositions/view/${id}?showclosebutton=${isShowEditor}`;
		},
	},
};
</script>
